<template>
    <div class="help-center-content">
        <h4>入驻平台</h4>
        <p class="title">1.  如何加入作品有声化平台？</p>
        <img :src="`${IMG_HOST}copyrightHelpCenter/img_2.jpeg`"  style="width: 592px;height: 329px;">
        <p class="content">首先，注册账号，在【我有作品】页面，点击【立即入驻】按钮开始入驻。</p>
        <img :src="`${IMG_HOST}copyrightHelpCenter/img_3.jpeg`"  style="width: 582px;border: 1px solid #eee;">
        <p class="content">按照要求填写个人或机构信息资料，并提交审核。</p>
        <p class="title">2.  加入作品有声化平台，我需要提供什么？</p>
        <p class="content"> 如果你是作家，你需要提供个人真实身份信息以及联络方式。<br>
            如果你代表版权机构，你需要提供机构注册信息以及联络方式。</p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// HelpCenterCopyrighterSignIn.vue?07a9824a